<template>
  <b-overlay
    :show="spinner"
    spinner-variant="primary"
  >
    <b-card>
      <b-row>
        <b-col
          lg="2"
          md="3"
          sm="3"
          class="my-1"
        >
          <!-- BOTON MOSTRAR -->
          <btnMostrar
            :pageOptions.sync="pageOptions"
            :perPage.sync="perPage"
            :total.sync="getSalidas.length"
          />
        </b-col>
        <b-col
          lg="6"
          md="5"
          sm="5"
          class="my-1"
        >
          <!-- FILTRO -->
          <inputFiltro
            :filter.sync="filter"
          />
        </b-col>
        <b-col
          md="4"
          sm="4"
          class="my-1"
        >
          <!-- BOTON CREAR -->
          <btnCrear
            texto="Salida"
            modulo="salidas"
            @processAdd="addSalida"
          />
        </b-col>

        <b-col cols="12">
          <b-table
            striped
            small
            hover
            noCollapse
            class="mt-1"
            responsive
            :per-page="perPage"
            :current-page="currentPage"
            :items="getSalidas"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :busy="cargando"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >

            <template #table-busy>
              <div class="text-center text-danger my-2">
                <spinner />
              </div>
            </template>
            <!-- COLUMNA VALOR TOTAL -->
            <template #cell(valorTotal)="data">
              ${{ data.item.valorTotal }}
            </template>

            <!-- Column: fecha -->
            <template #cell(fecha)="data">
              {{ formatearFecha(data.item.fecha) }}
            </template>

            <!-- Column: created_at -->
            <template #cell(created_at)="data">
              {{ formatearFechaHora(data.item.created_at) }}
            </template>

            <!-- Column: updated_at -->
            <template #cell(updated_at)="data">
              {{ formatearFechaHora(data.item.updated_at) }}
            </template>

            <!-- Column: Action -->
            <template #cell(acciones)="data">
              <colAccionesBtnes
                modulo="salidas"
                :data="data"
                @processGoToUpdate="goToUpdate"
                @processRemove="remove(data.item)"
              />
            </template>
          </b-table>
        </b-col>

        <b-col
          cols="12"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            size="sm"
            class="my-0"
          />
        </b-col>
      </b-row>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BTable, BRow, BCol, BPagination, BOverlay, BCard,
} from 'bootstrap-vue'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { formatos } from '@/mixins/forms'
import { avatarText } from '@core/utils/filter'

const colAccionesBtnes = () => import('@/layouts/components/Recycled/List/colAccionesBtnes.vue')
const btnCrear = () => import('@/layouts/components/Recycled/List/btnCrear.vue')
const inputFiltro = () => import('@/layouts/components/Recycled/List/inputFiltro.vue')
const btnMostrar = () => import('@/layouts/components/Recycled/List/btnMostrar.vue')
const spinner = () => import('@/layouts/components/Recycled/Form/spinner.vue')

export default {
  components: {
    BTable,
    BRow,
    BCol,
    BPagination,
    BOverlay,
    BCard,

    spinner,
    colAccionesBtnes,
    btnCrear,
    inputFiltro,
    btnMostrar,
  },
  mixins: [formatos],
  data() {
    return {
      spinner: false,
      cargando: true,
      perPage: 10,
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: '',
      filterOn: [],
      pageOptions: [3, 5, 10],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      fields: [
        {
          key: 'correlativo',
          label: '#',
          sortable: true,
          thStyle: {
            width: '0px !important',
            display: 'table-cell',
            'vertical-align': 'middle',
          },
        },
        {
          key: 'referencia',
          label: 'Referencia',
          sortable: true,
          thStyle: {
            width: '150px !important',
            display: 'table-cell',
            'vertical-align': 'middle',
          },
        },
        {
          key: 'fecha',
          label: 'Fecha',
          sortable: true,
          tdClass: 'text-center',
          thStyle: {
            'text-align': 'center',
            width: '90px !important',
            display: 'table-cell',
            'vertical-align': 'middle',
          },
        },
        {
          key: 'valorTotal',
          label: 'Valor Total',
          sortable: true,
          tdClass: 'text-center',
          thStyle: {
            'text-align': 'center',
            width: '50px !important',
            display: 'table-cell',
            'vertical-align': 'middle',
          },
        },
        {
          key: 'nombreCliente',
          label: 'Cliente',
          sortable: true,
          thStyle: {
            width: '150px !important',
            display: 'table-cell',
            'vertical-align': 'middle',
          },
        },
        {
          key: 'nombreUsuario',
          label: 'Creador',
          sortable: true,
          thStyle: {
            width: '150px !important',
            display: 'table-cell',
            'vertical-align': 'middle',
          },
        },
        {
          key: 'created_at',
          label: 'Fecha Creación',
          sortable: true,
          tdClass: 'text-left',
          thStyle: {
            'text-align': 'left',
            width: '130px !important',
            display: 'table-cell',
            'vertical-align': 'middle',
          },
        },
        {
          key: 'nombreUsuarioEdit',
          label: 'Última Edición',
          sortable: true,
          thStyle: {
            width: '150px !important',
            display: 'table-cell',
            'vertical-align': 'middle',
          },
        },
        {
          key: 'updated_at',
          label: 'Fecha Edición',
          sortable: true,
          tdClass: 'text-left',
          thStyle: {
            'text-align': 'left',
            width: '130px !important',
            display: 'table-cell',
            'vertical-align': 'middle',
          },
        },
        {
          key: 'acciones',
          label: 'acciones',
          tdClass: 'text-center',
          thStyle: {
            'text-align': 'center',
            width: '80px !important',
            display: 'table-cell',
            'vertical-align': 'middle',
          },
        },
      ],
    }
  },
  computed: {
    ...mapGetters({ getSalidas: 'salidas/getSalidas' }),

    // Vuexy
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  watch: {
    getSalidas(val) {
      this.totalRows = val.length
    },
  },
  mounted() {
    this.fetchSalidas().then(() => {
      this.cargando = false
    })
  },
  methods: {
    ...mapActions({
      fetchSalidas: 'salidas/fetchSalidas',
      removeSalidas: 'salidas/removeSalidas',
    }),
    ...mapMutations('salidas', ['setSalida']),
    addSalida() {
      this.$router.replace({
        name: 'salidas-create',
      })
    },
    goToUpdate(salida) {
      this.setSalida(salida)
      this.$router.push({
        name: 'salidas-update',
        params: { id: salida.id },
      })
    },
    remove(salida) {
      const referencia = salida.referencia != null
        ? `${salida.correlativo} - ${salida.referencia}`
        : salida.correlativo

      this.$swal({
        title: 'Eliminar salida!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, eliminala!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
        html: `
            <div style="margin-top:3%; text-align: center;">
              ¿Restablecer stock?
            </div>
            <div style="margin-top:2%; text-align: center;">
              <input type="radio" name="remove" value="siStock" checked/>
              <strong>SI</strong> &nbsp;
              <input type="radio" name="remove" value="noStock"/>
              <strong>NO</strong>
            </div>
            <br>

            ¿Estás seguro que deseas eliminar la salida "${referencia}"?
            <br><br>
          `,
      }).then(result => {
        this.spinner = true
        if (result.value) {
          const opcionStock = document.querySelector('input[name="remove"]:checked').value
          const opciones = {
            id: salida.id,
            opcionStock,
          }

          let text = `"${referencia}", `
          if (opcionStock === 'siStock') {
            text += 'ha sido eliminada y su stock fue restablecido!'
          } else if (opcionStock === 'noStock') {
            text += 'ha sido eliminada sin restablecer su stock!'
          }
          this.removeSalidas(opciones).then(() => {
            this.$swal({
              icon: 'success',
              title: 'Eliminada con éxito!',
              text,
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
            this.spinner = false
          })
        } else {
          this.spinner = false
        }
      })
    },

    // Vuexy
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
  setup() {
    return {
      avatarText,
    }
  },
}
</script>
